import React from 'react'
import MainLayout from '../../Layouts/Mainlayout'
import ESPSettings from './ESPList'

function ESPSettingsList(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <ESPSettings />
      </MainLayout>
    </div>
  )
}

export default ESPSettingsList